import React from 'react';
import { getInitials } from "../../helpers/formatting";
import PropTypes from 'prop-types';

const FamilyMemberProxyUsers = ({
    displayName,
    isPending,
    type
}) => {

    return (
        <div className='user-proxy__list-item'>
            <div className="row">
                <div className="col-12 d-flex">
                    <div className="user-proxy__icon">
                        <div className="user-avatar">
                            {getInitials(displayName)}
                        </div>
                    </div>
                    <div className="user-proxy__details" >
                        <div className="user-proxy__name">{displayName}</div>
                        <div className="user-proxy__pill">{type}</div>
                        {isPending && <div
                            className="user-proxy__status"
                        >Pending</div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

FamilyMemberProxyUsers.defaultProps = {
    displayName: "",
    isPending: false,
    type: ""
};

FamilyMemberProxyUsers.propTypes = {
    displayName: PropTypes.string,
    isPending: PropTypes.bool,
    type: PropTypes.string,
};

export default FamilyMemberProxyUsers;